// =============================================================
// VARIANCE — The Executive Command Center
// File      : VendorsLaunchpad.tsx
// Location  : /home/Applications/variance/web/src/pages/VendorsLaunchpad.tsx
// Owner     : VARIANCE frontend application only
// Purpose   : The hub page to select Contractor, Supplier, or Consultant.
// =============================================================

import { useNavigate } from 'react-router-dom';
import { HardHat, Truck, Users } from 'lucide-react';

export function VendorsLaunchpad() {
  const navigate = useNavigate();

  return (
    <div className="max-w-5xl mx-auto mt-12 mb-20">
      
      {/* Definition Header */}
      <div className="text-center mb-16 space-y-6">
        <h1 className="text-4xl md:text-5xl font-bold tracking-tight" style={{ color: 'var(--text-primary)' }}>Vendor Hub</h1>
        <div className="w-full flex justify-center">
          <p className="text-base md:text-lg leading-relaxed text-justify md:text-center max-w-4xl px-4" style={{ color: 'var(--text-secondary)' }}>
            A comprehensive registry of all external partners powering the enterprise, including 
            <span className="font-semibold" style={{ color: 'var(--brand-accent)' }}> Suppliers</span> (Materials), 
            <span className="font-semibold" style={{ color: 'var(--brand-accent)' }}> Contractors</span> (Execution), and 
            <span className="font-semibold" style={{ color: 'var(--brand-accent)' }}> Consultants</span> (Tech & Management Services).
          </p>
        </div>
      </div>

      {/* Launchpad Cards */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12">
        
        {/* Contractors Card */}
        <button 
          onClick={() => navigate('/vendors/Contractor')} 
          className="group relative p-10 rounded-2xl flex flex-col items-center gap-6 transition-all duration-300 border-2 border-[var(--border-subtle)] hover:border-[var(--brand-accent)] hover:shadow-[0_0_30px_var(--brand-accent)]"
          style={{ backgroundColor: 'var(--bg-panel)' }}
        >
          <div className="p-5 rounded-full transition-transform duration-300 group-hover:scale-110" style={{ backgroundColor: 'var(--bg-panel-alt)' }}>
            <HardHat size={56} style={{ color: 'var(--brand-accent)' }} />
          </div>
          <div className="text-center">
            <span className="block font-bold text-2xl mb-2" style={{ color: 'var(--text-primary)' }}>Contractors</span>
            <span className="block text-sm" style={{ color: 'var(--text-secondary)' }}>Execution & Construction Partners</span>
          </div>
        </button>

        {/* Suppliers Card */}
        <button 
          onClick={() => navigate('/vendors/Supplier')} 
          className="group relative p-10 rounded-2xl flex flex-col items-center gap-6 transition-all duration-300 border-2 border-[var(--border-subtle)] hover:border-[var(--brand-accent)] hover:shadow-[0_0_30px_var(--brand-accent)]"
          style={{ backgroundColor: 'var(--bg-panel)' }}
        >
          <div className="p-5 rounded-full transition-transform duration-300 group-hover:scale-110" style={{ backgroundColor: 'var(--bg-panel-alt)' }}>
            <Truck size={56} style={{ color: 'var(--brand-accent)' }} />
          </div>
          <div className="text-center">
            <span className="block font-bold text-2xl mb-2" style={{ color: 'var(--text-primary)' }}>Suppliers</span>
            <span className="block text-sm" style={{ color: 'var(--text-secondary)' }}>Materials & Goods Providers</span>
          </div>
        </button>

        {/* Consultants Card */}
        <button 
          onClick={() => navigate('/vendors/Consultant')} 
          className="group relative p-10 rounded-2xl flex flex-col items-center gap-6 transition-all duration-300 border-2 border-[var(--border-subtle)] hover:border-[var(--brand-accent)] hover:shadow-[0_0_30px_var(--brand-accent)]"
          style={{ backgroundColor: 'var(--bg-panel)' }}
        >
          <div className="p-5 rounded-full transition-transform duration-300 group-hover:scale-110" style={{ backgroundColor: 'var(--bg-panel-alt)' }}>
            <Users size={56} style={{ color: 'var(--brand-accent)' }} />
          </div>
          <div className="text-center">
            <span className="block font-bold text-2xl mb-2" style={{ color: 'var(--text-primary)' }}>Consultants</span>
            <span className="block text-sm" style={{ color: 'var(--text-secondary)' }}>Tech & Special Services</span>
          </div>
        </button>

      </div>
    </div>
  );
}
